import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) { setError('Please enter your email and password.'); return; }
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate('/superadmin', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-hero relative overflow-hidden px-4">
      <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-blue-400/8 rounded-full blur-3xl pointer-events-none" />

      <div className="w-full max-w-[380px] relative z-10">

        <div className="bg-white rounded-xl shadow-2xl p-7">
          <div className="flex flex-col items-center mb-8">
            <div className="w-14 h-14 rounded-lg bg-white flex items-center justify-center mb-4 shadow-lg">
              <img
                src="/manna-plag-favicon.png"
                alt="Manna Plag"
                style={{ width: 32, height: 32, objectFit: 'contain' }}
                onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
              />
            </div>
            <h1 className="text-[22px] font-black text-gray-900 tracking-tight">Admin Panel</h1>
            <p className="text-[13px] text-gray-500 font-medium mt-1">Sign in with your administrator account</p>
          </div>
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <div>
              <label className="text-[12px] font-bold text-gray-600 mb-1.5 block">Email address</label>
              <input
                type="email"
                placeholder="admin@mannaplag.com"
                value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }}
                className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-[13px] text-gray-900 placeholder-gray-400 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy/20 transition-all bg-white"
              />
            </div>

            <div>
              <label className="text-[12px] font-bold text-gray-600 mb-1.5 block">Password</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-[13px] text-gray-900 placeholder-gray-400 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy/20 transition-all bg-white pr-10"
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <i className={`ti ${showPass ? 'ti-eye-off' : 'ti-eye'}`} style={{ fontSize: 16 }} />
                </button>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-100 rounded-xl">
                <i className="ti ti-alert-circle text-red-500 flex-shrink-0" style={{ fontSize: 16 }} />
                <p className="text-[12px] text-red-600 font-medium">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-navy text-white text-[13px] font-black rounded-lg hover:bg-navy-dark transition-colors disabled:opacity-60 uppercase tracking-tight mt-1"
            >
              {loading ? 'Signing in…' : 'Sign in to admin panel'}
            </button>
          </form>
        </div>

        <p className="text-center mt-6">
          <Link to="/" className="text-[12px] text-white/40 font-medium hover:text-white/70 transition-colors">
            ← Back to main site
          </Link>
        </p>
      </div>
    </div>
  );
}
